import { Box, Typography } from '@mui/material';
import VisaIcon from '@acorn-portal/shared/src/assets/images/Visa.svg?react';
import MastercardIcon from '@acorn-portal/shared/src/assets/images/Mastercard.svg?react';
import { CreditCard } from '@mui/icons-material';
import { CardVendor, ExistingCardPaymentMethod } from '@acorn-portal/shared/src/services/api';

interface Props {
	card: ExistingCardPaymentMethod;
}

const ExistingCard = ({ card }: Props) => {
	const getCardIcon = (cardVendor: CardVendor) => {
		switch (cardVendor) {
			case CardVendor.Visa:
				return <VisaIcon height={75} width={190} />;
			case CardVendor.Mastercard:
				return <MastercardIcon height={75} />;
			case CardVendor.Other:
			default:
				return <CreditCard sx={{ height: '60px', marginTop: '10px' }} />;
		}
	};

	return (
		<Typography
			sx={{
				display: 'flex',
				alignItems: 'center',
				flexWrap: 'wrap',
				fontWeight: '600',
				fontSize: '1.2rem',
			}}
		>
			<Box
				component='span'
				sx={{
					width: '100px',
					'& svg': {
						marginRight: '0.5rem',
						width: 90,
						verticalAlign: 'middle',
					},
				}}
			>
				{getCardIcon(card.vendor)}
			</Box>
			{`**** **** **** ${card.last4Digits}`}
		</Typography>
	);
};

export default ExistingCard;
